import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GtmEvent } from '../types/GoogleAnalytics.types';

@Injectable()
export class GtmService {
  public dataLayerTopic$ = new Subject<any>();
  protected dataLayer: any[];

  public sendEvent(eventObj: GtmEvent): void {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push(eventObj);
  }
}
